"use client";

import { useMemo, useState } from "react";
import BaseProductDetails from "../../shared/product/base-product-details";
import ImageLoader from "../../../../common/ImageLoader";
import MediaViewer from "../../../../common/MediaViewer";
import VideoPlayer from "../../../../video/VideoPlayer";
import styles from "./index.module.css";
import { useProductPriceDisplay } from "../../shared/product/useProductPriceDisplay";

const EmptyProductImage = () => {
  return (
    <div className={styles.emptyProductImage}>
      <svg
        width="60"
        height="60"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.6"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M21 15l-5-5L5 21" />
      </svg>

      <div style={{ fontSize: "1.3rem" }}>
        No image available for this product.
      </div>
    </div>
  );
};

const ConvetiImageGallery = ({ media = [], enablePreview = true }) => {
  const [showMediaViewer, setShowMediaViewer] = useState(false);
  const validMedia = useMemo(
    () =>
      (media || []).filter((item) => item && (item.mediaThumb || item.mediaUrl)),
    [media],
  );

  if (validMedia.length === 0) {
    return <EmptyProductImage />;
  }

  return (
    <>
      <div
        className={`${styles.productImageGrid} ${
          validMedia.length === 1 ? styles.productImageGridSingle : ""
        }`}
      >
        {validMedia.map((item, index) => {
          const isWideTile = validMedia.length === 1 || (index + 1) % 3 === 0;

          return (
            <button
              key={item._id || item.mediaId || `${index}-${item.mediaName}`}
              type="button"
              className={`${styles.productImageTile} ${
                isWideTile ? styles.productImageTileWide : ""
              }`}
              onClick={() => {
                if (enablePreview) setShowMediaViewer(true);
              }}
              aria-label={`View product media ${index + 1}`}
            >
              {item.mediaType === "video" ? (
                <VideoPlayer
                  src={item.mediaUrl}
                  className={styles.productImageVideo}
                  skeletonStyle={{ width: "100%", minHeight: "52rem" }}
                  autoPlay
                  continuousPlay
                />
              ) : (
                <ImageLoader
                  media={item}
                  alt={item.name || item.mediaName}
                  imgRes="900"
                  zoomImgRes="1500"
                  skeletonStyle={{ width: "100%", height: "100%" }}
                  imageStyle={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              )}
            </button>
          );
        })}
      </div>

      {showMediaViewer && enablePreview && (
        <MediaViewer media={validMedia} setShowMediaViewer={setShowMediaViewer} />
      )}
    </>
  );
};

const ProductDetails = (props) => (
  <BaseProductDetails
    {...props}
    styles={styles}
    usePriceDisplay={useProductPriceDisplay}
    ImageGalleryComponent={ConvetiImageGallery}
  />
);

export default ProductDetails;
